import Slide from './Slide'	

(() => {
	const INSTANCES = []
	class BlogSlider {
		constructor() {
			INSTANCES.push(this);
			 this.init();
		}

		static get INSTANCES () {
			return INSTANCES
		}

		init() {
			this.Dom = document.querySelector("[blog-slider-container]");
			this.slides = this.getSlides();
			this.registerButtonAction();
			this.buildPairButton();
		}

		buildPairButton(){
			let ol = document.createElement("ol");
			ol.setAttribute('class','carousel-indicators');
			ol.setAttribute('data-button-list','');
			let li;
			for (let i = 0; i < this.count; i++) { 
				let li = document.createElement("li");
				li.setAttribute('class','');
				li.setAttribute('blog-slider-button','chosen');
				li.setAttribute('data-pair',i);
				li.addEventListener('click',this.buttonHandler.bind(this,li));
				ol.appendChild(li);
			}
			this.Dom.appendChild(ol);
			this.slides.forEach(slide => { 
				slide.bindButton();
			});

		}

		registerButtonAction(){
			let buttonList = document.querySelectorAll('[blog-slider-button]');	
			[...buttonList].forEach(button => { 
				button.addEventListener('click',this.buttonHandler.bind(this,button));
			});
		}

		buttonHandler(button){
			let dir = button.getAttribute('blog-slider-button');
			this[dir+'Pair'](button);
		}

		getSlides(){
			let slides = this.Dom.querySelectorAll('[blog-slider-item]');
			let slideslist = [];
			let seq = 0;
			[...slides].forEach(slide => { 
				slideslist.push(new Slide(slide, this ,Math.floor(seq/2 )));
				seq++
			});
			this.count = Math.ceil(seq/2 );

			return slideslist;
		}

		getActivePair(){
			let active = 0;
			[...this.slides].forEach(slide => { 		
				if(slide.element.classList.contains('active')){
					active =  slide.pair;
				}
			});
			return active ;
		}

		nextPair(){
			let active = this.getActivePair();
			let next =active + 1;
			if(next < this.count ){
				[...this.slides].forEach(slide => { 
				
					if(slide.pair == next)
						slide.show('next');
					else
						slide.hide('next');	
				});
			}else{
				this.slides.forEach(slide => { 
					if(slide.pair == 0)
						slide.show('next');
					else
						slide.hide('next');	
				});
			}
		}

		chosenPair(button){
		
			let chosen = button.getAttribute('data-pair');
					button.setAttribute('class','active');
				this.slides.forEach(slide => { 
					if(slide.pair == chosen)
						slide.show('next');
					else
						slide.hide('next');	
				});
			
		}

		prevPair(sequence){
			let active = this.getActivePair();
			let prev =active - 1;

			if(prev >= 0 ){
				[...this.slides].forEach(slide => { 
					if(slide.pair == prev)
						slide.show('prev');
					else
						slide.hide('prev');	
				});
			}else{
				[...this.slides].forEach(slide => { 
					if(slide.pair == this.count - 1)
						slide.show('prev');
					else
						slide.hide('prev');	
				});
			}
		}
	}

	if(window.BlogSlider == undefined)
		window.BlogSlider = BlogSlider
	else
		throw new Error("ERROR: BlogSlidercall multiple times")
})()


// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/modules/BlogSlider.js